<template>
    <div :id="divName"></div>
</template>

<script setup>
  import {ref, onMounted, watch, toRefs, computed } from "vue";
  import * as d3 from 'd3';

  const props = defineProps({
    name:{type: String, default: null},
    divName:{type: String},
    min:{type:Number},
    max:{type:Number},
    value:{type:Number},
    unit: {type: String, default: null},
    valueType: {type: String, default: "Median"}
  })

  const { divName, min, max, value, name, unit, valueType } = toRefs(props)

  const wid = 220
  const ht = 200


  onMounted(() => {
    updateLine()
  })
  
  watch(value, (newVal, oldVal)=>{
    if (JSON.stringify(newVal) !== JSON.stringify(oldVal)){
      updateLine()
    }
  })


  const updateLine = () => {
    const chartSelector = divName.value;
    d3.select("#" + chartSelector).select("svg").remove();
    // set the dimensions and margins of the graph
    const margin = {top: 20, right: 20, bottom: 110, left: 20};
    const width = wid - margin.left - margin.right;
    const height = ht - margin.top - margin.bottom;

    // append the svg object to the div '
    const svg = d3.select('#' + chartSelector)
      .append('div')
        .classed("svg-container", true)
      .append("svg")
        .attr("preserveAspectRatio", "xMinYMin meet")
        .attr("viewBox", "0 0 " + width + " " + height)
        .classed("svg-content-responsive", true)
      .append("svg")
        .attr("width", width)
        .attr("height", height)


    // const min = 0;
    // const max = 100;
    // const value = 75;

    const x = d3.scaleLinear()
      .domain([min.value, max.value])
      .range([margin.left, width - margin.right]);

    const xAxis = d3.axisBottom(x)
      .ticks(1) // only show min & max.  more 
      .tickFormat(d3.format("d"))
      .tickValues(d3.range(min.value, max.value, (max.value - min.value) / 1).concat([min.value, max.value]));

    svg.append("g")
      .attr("transform", `translate(0,${height / 2})`)
      .attr("class", "axis")
      .call(xAxis)
      .selectAll("text")
      .attr("class", "tickText");

    // // Circle as value tick
    // svg.append("circle")
    //   .attr("cx", x(value.value))
    //   .attr("cy", height / 2)
    //   .attr("r", 5)
    //   .attr("fill", "red");

    // line as value tick
    svg.append("line")
      .attr("x1", x(value.value))
      .attr("x2", x(value.value))
      .attr("y1", height / 2 - 7)
      .attr("y2", height / 2 + 7)
      .attr("class", "valueTick");

    // add a label for the value
    svg.append("text")
      .attr("x", x(value.value))
      .attr("y", height / 2 - 20)
      .attr("class", "valueLabel")
      .attr("text-anchor", "middle")
      .text(`${value.value} ${unit.value}`);

      // add a label under the value to indicate type (e.g. median, mean)
      svg.append("text")
        .attr("x", x(value.value))
        .attr("y", height / 2 -10)
        .attr("class", "valueTypeLabel")
        .attr("text-anchor", "middle")
        .text(valueType.value);

    // add "min" and "max" under the min and max values
    svg.append("text")
      .attr("x", x(min.value))
      .attr("y", height / 2 + 30)
      .attr("class", "minMaxLabel")
      .attr("text-anchor", "middle")
      .text("Min");

    svg.append("text")
      .attr("x", x(max.value))
      .attr("y", height / 2 + 30)
      .attr("class", "minMaxLabel")
      .attr("text-anchor", "middle")
      .text("Max");
  }

    

</script>
<style >
.q-dark .tooltip{
  background-color: #2e2e2e;
}
.tooltip{
  background-color: white;
  color: black
}
.q-dark &.tooltip{
  background-color: #2e2e2e;
}
.tickText{
  font-size: 12px;
  color: black;
}
.valueLabel {
    font-size: 14px;
    font-weight: bold;
    fill: #1D8177;
}
.valueTick{
  stroke: #1D8177;
  stroke-width: 3px;
}
.minMaxLabel{
  font-size: 10px;
  color: black;
  padding-top: 3px; 
}
.valueTypeLabel{
    font-size: 12px;
    fill: #1D8177;
    padding-top: 3px; 
}
</style>
